import { NavLink, Navigate, Outlet } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Wordmark } from "@/components/brand/Wordmark";

const NAV = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/subscribers", label: "Subscribers" },
  { to: "/admin/review-queue", label: "Review queue", roles: ["owner"] },
  { to: "/admin/trustee-help", label: "Trustee help" },
  { to: "/admin/market-prices", label: "Market prices" },
  { to: "/admin/exchange-rates", label: "Exchange rates" },
  { to: "/admin/vendors", label: "Vendors" },
  { to: "/admin/health", label: "Health & AI cost" },
  { to: "/admin/settings", label: "Configuration" },
  { to: "/admin/admins", label: "Admin accounts", roles: ["owner"] },
  { to: "/admin/emails", label: "Outbound email", roles: ["owner", "support"] },
  { to: "/admin/audit", label: "Audit log" },
];

export default function AdminShell() {
  const { admin, logout } = useAdminAuth();
  if (admin === null) return <div className="min-h-screen" style={{ background: "var(--navy)" }} />;
  if (admin === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex" style={{ background: "var(--paper)" }}>
      <aside className="w-60 shrink-0 flex flex-col p-5 text-white" style={{ background: "var(--navy)" }} data-testid="admin-sidebar">
        <span style={{ filter: "invert(1) hue-rotate(180deg)" }}><Wordmark showStatus={false} suffix="Admin" /></span>
        <nav className="mt-10 flex flex-col gap-1 text-sm" aria-label="Admin">
          {NAV.filter((n) => !n.roles || n.roles.includes(admin.role)).map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `px-3 py-2 rounded transition-colors ${isActive ? "bg-white/10 font-semibold" : "text-white/70 hover:bg-white/5 hover:text-white"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto text-xs text-white/60">
          <div data-testid="admin-identity" className="truncate">{admin.email}</div>
          <div className="eyebrow mt-1" style={{ color: "#7DA2F5" }} data-testid="admin-role">{admin.role}</div>
          <button onClick={logout} className="mt-3 underline hover:text-white" data-testid="admin-logout-button">Sign out</button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-8 lg:p-12">
        <Outlet />
      </main>
    </div>
  );
}
